import React from 'react'

const NotFound = () => {
  return (
    <div className='vh-100'>
        <h1 className='text-center display-1 fw-bold'>404</h1>
        <h1 className='text-center display-2 fw-bold'>Page Not Found</h1>
    </div>
  )
}

export default NotFound;